import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SubSink } from 'subsink2';
import { ClientSidePermissionsSelectors } from '../../permission/client-side-permissions-controller/selectors';
import { ClientSidePermissionStates } from '../../permission/client-side-permissions-controller/states';

@Component({
  selector: 'app-feature-visibility',
  templateUrl: './feature-visibility.component.html',
  styleUrls: ['./feature-visibility.component.css']
})
export class FeatureVisibilityComponent implements OnInit, OnDestroy {

  private subs = new SubSink();

  permissionList$ = this.store.select(ClientSidePermissionsSelectors.selectAll);

  constructor(private readonly store: Store<ClientSidePermissionStates>) { }

  ngOnInit() {
    this.permissionList$.subscribe(a => console.log(a))
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
